import { Utilisateur } from './utilisateur.model';

export class ListUtilisateur{
    constructor(public maxUtilisateur?:number,
        public utilisateurs?:Utilisateur[]){}
}